import { useQuery } from '@tanstack/react-query'
import { getUserSessions } from '../../../data/userSessions'
import { UserFriendlyError } from '../../../model/Error'
import { userSessionsKeys } from './userSessions.keys'

interface UseGetUserSessionsParams {
  enabled?: boolean
}

export const useGetUserSessions = ({ enabled = true }: UseGetUserSessionsParams = {}) => {
  const query = useQuery({
    queryKey: userSessionsKeys.devices,
    queryFn: async ({ signal }) => {
      const { data, ok } = await getUserSessions(signal)

      if (!data || !ok) {
        throw new UserFriendlyError(
          'error',
          'Impossible de charger vos appareils connectés',
          'Une erreur est survenue. Vérifiez votre connexion et réessayez.',
        )
      }

      return data
    },
    enabled,
  })

  return { query }
}
